import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from "@ngrx/store";
import ICertification from "@skills-app/models/certification";
import { CertificationsPageActions } from "@skills-app/certifications/actions";
import { SortType } from "@skills-app/models/sorting";

export interface ICertificationsState {
  allCertifications: ICertification[];
  sortAscending: boolean;
  sortType: SortType;
  onlyRecent: boolean;
}

const initialState: ICertificationsState = {
  allCertifications: [],
  sortType: 0,
  sortAscending: true,
  onlyRecent: false,
};

export const reducer = createReducer(
  initialState,

  on(
    CertificationsPageActions.requestAllCertificationsSuccess,
    (state, action) => ({
      ...state,
      allCertifications: action.certifications,
    }),
  ),

  on(CertificationsPageActions.updateSort, (state, action) => ({
    ...state,
    sortType: action?.value?.SortType,
    sortAscending: action?.value?.Ascending,
  })),

  on(
    CertificationsPageActions.setOnlyRecentCertifications,
    (state, action) => ({
      ...state,
      onlyRecent: action.value,
    }),
  ),
);

export const getCertificationsState =
  createFeatureSelector<ICertificationsState>("certifications");

export const getAllCertifications = createSelector(
  getCertificationsState,
  (consultantsState) => consultantsState.allCertifications,
);

export const getSortedCertifications = createSelector(
  getCertificationsState,
  (certificationState) => {
    let currentCerts = [...certificationState.allCertifications];

    if (certificationState.onlyRecent) {
      const cutoffDate = new Date();
      // Can be up to one day out but honestly I dont think it matters that much
      cutoffDate.setMonth(cutoffDate.getMonth() - 3);

      currentCerts = currentCerts.filter((x) => {
        const t = x.LastModifiedTime;
        if (!t) return false; // drop items with no date when filtering for "recent"
        return new Date(t) > cutoffDate;
      });
    }

    if (certificationState.sortType == SortType.Name) {
      currentCerts = currentCerts.sort((a, b) => a.Title.localeCompare(b.Title));
    } else {
      currentCerts = currentCerts.sort((a, b) => {
        const ta = a.LastModifiedTime ? new Date(a.LastModifiedTime).getTime() : 0;
        const tb = b.LastModifiedTime ? new Date(b.LastModifiedTime).getTime() : 0;
        return ta - tb;
      });
    }

    return certificationState.sortAscending ? currentCerts : currentCerts.reverse();
  },
);
